import * as React from 'react';
import { Link, LinkProps } from 'react-router-dom';
import styled from 'styled-components';

import { DropdownMenuItem } from './DropdownMenuItem';

const LinkStyled = styled(Link)`
  text-decoration: none;
`;

type DropdownMenuLinkItemProps = Omit<React.ComponentProps<typeof DropdownMenuItem>, 'asChild'> & {
  to: LinkProps['to'];
  state?: LinkProps['state'];
  target?: LinkProps['target'];
  replace?: boolean;
  reloadDocument?: LinkProps['reloadDocument'];
};

export const DropdownMenuLinkItem = ({
  children,
  to,
  state,
  target,
  replace,
  reloadDocument,
  ...itemProps
}: DropdownMenuLinkItemProps): React.JSX.Element => {
  return (
    <DropdownMenuItem asChild {...itemProps}>
      <LinkStyled to={to} state={state} target={target} replace={replace} reloadDocument={reloadDocument}>
        {children}
      </LinkStyled>
    </DropdownMenuItem>
  );
};
